import React from 'react'

// One card in step 2's spot-decision list: icon, title + badge, one-line description,
// and a radio dot — the whole card is clickable, not just the dot.
export const SpotOptionCard = ({
  selected,
  danger,
  icon,
  title,
  badge,
  description,
  disabled,
  onSelect,
}: {
  selected: boolean
  danger?: boolean
  icon: React.ReactNode
  title: React.ReactNode
  badge: React.ReactNode
  description: React.ReactNode
  disabled: boolean
  onSelect: () => void
}) => (
  <div
    className={`spot-opt ${selected ? 'sel' : ''} ${selected && danger ? 'danger' : ''}`}
    role="radio"
    aria-checked={selected}
    aria-disabled={disabled}
    tabIndex={disabled ? -1 : 0}
    onClick={() => !disabled && onSelect()}
    onKeyDown={e => {
      if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault()
        onSelect()
      }
    }}
  >
    <div>{icon}</div>
    <div className="spot-opt-body">
      <div className="spot-opt-title">
        {title} {badge}
      </div>
      <div className="spot-opt-desc">{description}</div>
    </div>
    <div className="spot-opt-radio" />
  </div>
)
